export default "__VITE_ASSET__WNROxei8__"